import { checkDigitAlgorithm as checkDigitAlgorithmFun } from '../../app/helpers';

export function checkDigitAlgorithm() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.checkDigitAlgorithm = function (modelValue, viewValue) {

                return checkDigitAlgorithmFun(modelValue || '');
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/check-digit-algorithm.js